export const OPEN_DOCUMENTS_DOWNLOAD_FILES = 'OPEN_DOCUMENTS_DOWNLOAD_FILES'
export const CLOSE_DOCUMENTS_DOWNLOAD_FILES = 'CLOSE_DOCUMENTS_DOWNLOAD_FILES'
export const REMOVE_DOCUMENTS_DOWNLOAD_FILES = 'REMOVE_DOCUMENTS_DOWNLOAD_FILES'
export const GET_SELECTED_DOCUMENTS_IN_DEEP = 'GET_SELECTED_DOCUMENTS_IN_DEEP'
export const POST_DOWNLOAD = 'POST_DOWNLOAD'
